import { render, staticRenderFns } from "./TkCrossMark.vue?vue&type=template&id=48c8a880&scoped=true&functional=true&"
import script from "./TkCrossMark.vue?vue&type=script&lang=js&"
export * from "./TkCrossMark.vue?vue&type=script&lang=js&"
import style0 from "./TkCrossMark.vue?vue&type=style&index=0&id=48c8a880&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "48c8a880",
  null
  
)

export default component.exports